(function () {
    'use strict';

    angular
        .module('salesflare')
        .service('currencies', currenciesService);

    function currenciesService(sfHttp, config) {

        this.get = function () {

            return sfHttp.get(config.apiUrl + 'currencies', { cache: true });
        };
    }
})();
